const topicsData = [
  { label: '国产剧推荐', count: '2.3万讨论', hot: true },
  { label: '经典老片重温', count: '1.8万讨论', hot: true },
  { label: '悬疑推理剧场', count: '1.6万讨论', hot: true },
  { label: '古装巨制', count: '1.5万讨论', hot: false },
  { label: '科幻电影', count: '9,862讨论', hot: false },
  { label: '现实主义题材', count: '8,741讨论', hot: false },
  { label: '喜剧笑点合集', count: '7,528讨论', hot: false },
  { label: '动作大片', count: '6,934讨论', hot: false },
  { label: '网络自制剧', count: '6,210讨论', hot: false },
  { label: '纪录片精选', count: '5,483讨论', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1200px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
            热门话题
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            国产影视爱好者正在热议的话题，加入讨论发现更多好片
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-2 md:gap-3">
          {topicsData.map((topic) => (
            <div
              key={topic.label}
              className={`inline-flex items-center gap-2 px-3 md:px-4 py-2 rounded-full border cursor-pointer transition-all hover:scale-105 whitespace-nowrap ${
                topic.hot
                  ? 'bg-primary-50 border-primary-200 text-primary-700 hover:bg-primary-100'
                  : 'bg-background-100 border-background-200/70 text-foreground-600 hover:bg-background-200'
              }`}
            >
              <span className="text-xs md:text-sm font-medium">{topic.label}</span>
              <span className="text-[10px] md:text-xs text-foreground-400">{topic.count}</span>
              {topic.hot && (
                <span className="text-[10px] font-medium text-accent-600 bg-accent-100 px-1.5 py-0.5 rounded-full">
                  热
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}